module.exports = __webpack_public_path__ + "img/DS2422+.300b5bbb.png";